export default __webpack_public_path__ + "static/media/nolimit-logo-flat.53e0bf6d.svg";